import React from "react";
import { Link } from "react-router-dom";
import { useTenant } from "../TenantContext";
import { getLandingPathForTenant } from "../guards";

export default function ForbiddenPage({ reason, detail }) {
  const { tenant, error } = useTenant();
  const landing = getLandingPathForTenant(tenant);
  const message =
    detail ||
    error?.message ||
    (reason === "unknown-kind"
      ? "This Master Account has an unsupported tenant kind. Access is blocked."
      : reason === "missing-capability"
        ? "You do not have permission to open this page for this tenant."
        : reason === "impersonation-forbidden"
          ? "This page is not available during Support Mode."
          : reason === "path-not-in-experience"
            ? "This page is not part of your tenant experience."
            : "You are not authorized to view this page.");

  return (
    <div style={{ padding: 32, maxWidth: 560 }} data-testid="tenant-forbidden">
      <h1 style={{ fontSize: 22, marginBottom: 12 }}>Unavailable</h1>
      <p style={{ marginBottom: 8 }}>{message}</p>
      {reason ? (
        <p style={{ color: "#666", fontSize: 13 }}>Reason: {reason}</p>
      ) : null}
      {landing ? (
        <p style={{ marginTop: 20 }}>
          <Link to={landing}>Return to your tenant home</Link>
        </p>
      ) : null}
    </div>
  );
}
